<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formDevolution">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printDocument()"></app-custom-button>
              <app-custom-modal #selectOptionPrint [label]="'Seleccionar'" [header]="'Opciones de Impresión'"
                [children]="componentOptionPrintModal" [width]="'20rem'" (params)="printPredevolution($event)"
                hidden></app-custom-modal>

              <!-- Adjuntar archivos -->
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFileDevolution [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
                [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
                hidden></app-custom-modal>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteDevolution()"></app-custom-button>


              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewDevolution(formDevolution.get('branchId')?.value)"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="devolutionContract.userNameCreate"
                [createDate]="devolutionContract.createDate" [userNameUpdate]="devolutionContract.userNameUpdate"
                [updateDate]="devolutionContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="row">
              <div class="col-lg-7">
                <div class="row pe-md-3 py-md-2">
                  <div class="col field-branch">
                    <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                      [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)">
                    </app-custom-select>
                  </div>
                  <div class="col field-consecutive">
                    <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                      [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                  </div>
                  <div class="col field-alter-number">
                    <app-custom-input-number formControlName="alterNumber"
                      [labelText]="'Nro.Alterno'"></app-custom-input-number>
                  </div>
                  <div class="col field-type-devolution">
                    <app-custom-input-text [disabled]="true" [labelText]="'Tipo'"
                      [value]="devolutionContract.isTransfer ? 'Traslado' : 'Devolución'">
                    </app-custom-input-text>
                  </div>
                  <div class="col field-type-devolution">
                    <app-custom-select formControlName="isPredevolution" [labelText]="'Tipo Documento'"
                      [required]="true" [list]="listTypeDocument"
                      [inputClass]="devolutionContract.isPredevolution ? 'state-inactive' : ''"
                      (onChangeSelect)="getTypeDocument($event)">
                    </app-custom-select>
                  </div>
                  <div class="col field-convert-to-devolution d-flex align-items-end">
                    <app-custom-button [disabled]="!devolutionContract.isPredevolution"
                      [title]="'Convertir a Devolución'" [label]="'Conv.A Dev.'" [severity]="'success'"
                      [variant]="undefined" [icon]="'pi pi-sync'" [width]="'7rem'" (onClick)="convertToDevolution()">
                    </app-custom-button>
                  </div>
                  <div class="col field-dates">
                    <app-custom-datepicker formControlName="datePredevolution" [labelText]="'Fec.Predevol.'"
                      [required]="devolutionContract.isPredevolution" (onChangeDate)="changeDatePredevolution()">
                    </app-custom-datepicker>
                  </div>
                  <div class="col field-advertiser">
                    <app-custom-input-text formControlName="advertiser" [labelText]="'Anunciante'"
                      [required]="devolutionContract.isPredevolution" [maxLength]="50">
                    </app-custom-input-text>
                  </div>
                  <div class="col field-dates">
                    <app-custom-datepicker formControlName="dateDevolution" [labelText]="'Fec.Devolución'"
                      [required]="true" (onChangeDate)="changeDateDevolution()"></app-custom-datepicker>
                  </div>
                  <div class="col field-dates">
                    <app-custom-datepicker formControlName="dateInvoice" [labelText]="'Fec.Facturación'"
                      [required]="true" (onChangeDate)="changeDateInvoice()"></app-custom-datepicker>
                  </div>
                  <div class="col field-dont-charge-invoice-day d-flex align-items-end mb-1 mt-2">
                    <app-custom-checkbox formControlName="swDontChargeInvoiceDay"
                      [labelText]="'No Cobrar Día Facturación'"></app-custom-checkbox>
                  </div>
                  <div class="row">
                    <div class="col field-client-cost-center">
                      <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClient"
                        [required]="true" [class]="stateClientId === 1 ? '' : 'text-danger'"
                        (onChangeSelect)="getClient($event, true)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col field-client-cost-center">
                      <app-custom-autocomplete formControlName="costCenterId" [labelText]="'Centro de Costos'"
                        [list]="filteredCostCenters" [class]="stateCostCenterId === 1 ? '' : 'state-inactive'"
                        [required]="true" (onChangeSelect)="getCostCenter($event, false)">
                      </app-custom-autocomplete>
                    </div>
                  </div>
                  @if (swIndicators) {
                  <div class="row">
                    <div class="col field-transporter">
                      <app-custom-autocomplete formControlName="transporterId" [labelText]="'Transportador'"
                        [list]="listTransporter" [required]="true" (onChangeSelect)="getTransporter($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col field-vehicle">
                      <app-custom-autocomplete formControlName="vehicleId" [labelText]="'Vehículo'" [list]="listVehicle"
                        [required]="true" (onChangeSelect)="getVehicle($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col field-values">
                      <app-custom-input-decimal formControlName="transportValue" [labelText]="'Vr.Trans.Cobrar'"
                        (onChangeNumber)="changeTransportValue()"></app-custom-input-decimal>
                    </div>
                    <div class="col field-values">
                      <app-custom-input-decimal formControlName="transportValuePay"
                        [labelText]="'Vr.Trans.Pagar'"></app-custom-input-decimal>
                    </div>
                  </div>
                  }
                  <div class="row">
                    <div class="col">
                      <app-custom-textarea formControlName="printObservation" [labelText]="'Observación Impresión'"
                        [autoResize]="false" [rows]="1" [maxLength]="250"></app-custom-textarea>
                    </div>
                    <div class="col">
                      <app-custom-textarea formControlName="observation" [labelText]="'Observación'"
                        [autoResize]="false" [rows]="1" [maxLength]="250"></app-custom-textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-5">
                <div class="row ps-md-3 py-md-2">
                  <div class="col-lg-3 col-md-2 col-sm-3 col-6">
                    <app-custom-tag [label]="'Estado'"
                      [severity]="devolutionContract.devolutionStateId === devolutionStateOpen ? 'danger':''"
                      [value]="devolutionStateString"></app-custom-tag>
                  </div>
                  <div class="col-lg-9 col-md-10 col-sm-9 col-12 d-flex align-items-end mt-3 gap-1">
                    <app-custom-button [icon]="iconStateDevolution" [title]="titleStateDevolution"
                      [severity]="'primary'" (onClick)="changeDevolutionState()"></app-custom-button>
                    <app-custom-button [title]="'Anular'" [icon]="'pi pi-ban'" [severity]="'warn'"
                      (onClick)="annulDevolution()"></app-custom-button>
                    <app-custom-checkbox formControlName="swBlock" class="" [labelText]="'Bloq.'"
                      (onChangeCheckBox)="blockDevolution($event)"></app-custom-checkbox>

                    <app-custom-chip class="ms-2 me-1" [label]="'Corte: ' + invoicingCutoffCode" />

                    <app-custom-chip class="me-1"
                      [ngClass]="devolutionContract.rentalPeriod.active == true ? '' : 'text-danger'"
                      [label]="'Periodo: ' + dataPeriod" />
                  </div>
                  @if (!swIndicators) {
                  <div class="col field-transporter">
                    <app-custom-autocomplete formControlName="transporterId" [labelText]="'Transportador'"
                      [list]="listTransporter" [required]="true" (onChangeSelect)="getTransporter($event)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="col field-vehicle">
                    <app-custom-autocomplete formControlName="vehicleId" [labelText]="'Vehículo'" [list]="listVehicle"
                      [required]="true" (onChangeSelect)="getVehicle($event)">
                    </app-custom-autocomplete>
                  </div>
                  <div class="col field-values">
                    <app-custom-input-decimal formControlName="transportValue" [labelText]="'Vr.Trans.Cobrar'"
                      (onChangeNumber)="changeTransportValue()"></app-custom-input-decimal>
                  </div>
                  <div class="col field-values">
                    <app-custom-input-decimal formControlName="transportValuePay"
                      [labelText]="'Vr.Trans.Pagar'"></app-custom-input-decimal>
                  </div>
                  }
                  <div class="row">
                    <div class="col field-wildcards">
                      <app-custom-input-text formControlName="wildcard" [labelText]="'Comodín 1'"
                        [maxLength]="20"></app-custom-input-text>
                    </div>
                    <div class="col field-wildcards">
                      <app-custom-input-text formControlName="wildcard2" [labelText]="'Comodín 2'"
                        [maxLength]="20"></app-custom-input-text>
                    </div>
                  </div>
                  @if (swIndicators) {
                  <div class="col-12 fieldset-devolution">
                    <p-fieldset legend="Indicadores">
                      <div class="row fieldset-content py-1">
                        <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                          <app-custom-datetime-picker formControlName="datePickup" [labelText]="'Fecha Recogida'"
                            [required]="false"></app-custom-datetime-picker>
                        </div>
                        <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                          <app-custom-select formControlName="conceptTypeRequirementId"
                            [labelText]="'Tipo Requerimiento'" [list]="listTypeRequirements" [required]="false"
                            [showClear]="true"></app-custom-select>
                        </div>
                        <div class="col-lg-6 col-md-4 col-sm-6 col-12">
                          <app-custom-select formControlName="conceptDelayReasonId" [labelText]="'Motivo Demora'"
                            [list]="listDelayReasons" [required]="false" [showClear]="true"></app-custom-select>
                        </div>
                      </div>
                    </p-fieldset>
                  </div>
                  }
                  <div class="col-12 d-flex justify-content-end mt-3">
                    <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                      [disabled]="disabledForm ? disabledBtnSave : false" (onClick)="onSave()">
                    </app-custom-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-devolution-detail [devolutionModel]="devolutionContract" [disabledDetail]="disabledDetail"
      [updateListDetail]="updateListDetail" (updateList)="getUpdateListDetail()"
      (emitQuantityDetails)="getQuantityDetails($event)" (devolutionDetailRepair)="getDevolutionDetailRepair($event)"
      (openModalRepair)="openRepairModal()">
    </app-devolution-detail>
  </div>
</section>

<!-- Imprimir Predevolución -->
<app-print-predevolution *ngIf="devolutionContract.isPredevolution" id="print-predevolution" [reloadPrint]="reloadPrint"
  [companyId]="companyId" [predevolutionPrintModel]="devolutionPrintModel" [printOnlyQuantity]="printOnlyQuantity"
  [swIncludeStore]="swIncludeStore" [printOnlyStore]="printOnlyStore" [focusText]="true" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-predevolution>

<!-- Imprimir Devolución -->
<app-print-devolution *ngIf="!devolutionContract.isPredevolution" id="print-devolution"
  [swIncludeStore]="swIncludeStore" [reloadPrint]="reloadPrint" [companyId]="companyId"
  [devolutionPrintModel]="devolutionPrintModel" [focusText]="true" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-devolution>

<!-- Modal de reparación -->
<app-custom-modal #repairModal [label]="headerRepair" [header]="headerRepair" [inputs$]="inputsForRepairModals$"
  [children]="componentRepairModal" [closable]="false" (params)="reloadListDetail($event)" hidden>
</app-custom-modal>

<!-- Modal consecutivo inicial (sin registros) -->
<app-custom-modal #initialConsecutive [header]="'Número de documento inicial'"
  [children]="componentInitialConsecutiveModal" [width]="'25rem'" hidden [output$]="outputForInitialConsecutive$">
</app-custom-modal>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>